import { useEffect, useRef } from 'react'
// Inlined: a chunk referencing a worker URL gets its whole sourcemap regenerated by Vite, which runs the build out of heap.
import IntervalTickerWorker from '../workers/intervalTicker.worker?worker&inline'

// Ticks come from a Web Worker because Chrome throttles main-thread timers in hidden tabs to about once a minute.
export function useWorkerInterval(callback: () => void, delayMs: number | null): void {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  })

  useEffect(() => {
    if (delayMs === null) return
    const worker = new IntervalTickerWorker()
    worker.onmessage = () => callbackRef.current()
    worker.postMessage(delayMs)

    return () => worker.terminate()
  }, [delayMs])
}
